class PopupModel {
  buttonClicked: any = null;
  cancelClicked: any = null;
  focusElement: any = null;
  buttonDisabled: any = null;
  isModal: any = null;
}

export default PopupModel;
